var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showSeason)?_c('span',{staticClass:"badgeSeason"},[_vm._v("season")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }